import { render, staticRenderFns } from "./TablePackages.vue?vue&type=template&id=6e9cd6d8"
import script from "./TablePackages.vue?vue&type=script&lang=js"
export * from "./TablePackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports